/**
 * This file is automatically generated. Do not modify it manually.
 */
export interface AppFeatures {
  'feat_000929_ndp_cb10_included_economy_light': string;
  'feat_000930_ndp_seat_included_premium_classic': string;
  'feat_001888_ndp_fare_price_vs_competitors': string;
  'feat_001903_bag_price_test': string;
  'feat_001904_seat_price_test_v2': string;
  'feat_001987_discount_for_3_4_5_seat': string;
  'feat_002114_premium_pricing': string;
  'feat_002449_middle_seat_price_test': string;
  'feat_2746_nationality_field_required_bookingflow': string;
  'feat_002880_premium_middle_seat_price_increase': string;
  'feat_002910_increase_round_trip_profitability': string;
  'feat_003119_round_trip_discount_v2': string;
  'feat_003290_premium_cabin_seat_price_test': string;
  'feat_003402_bag_price_test_v2': string;
  'feat_003403_flextra_classic_pricing_change': string;
  'feat_app_000001_can_edit_ssrs': boolean;
  'feat-000127-cabin-promo-module-desktop': string;
  'feat-000129-cabin-promo-module-mobile': string;
  'feat-000130-credit-card-number-spacing-enhancement': string;
  'feat-000131-disable-continue-button-under-modify-ticket-action': string;
  'feat-000132-urgency-and-positive-reinforcement-messaging-flights': string;
  'feat-000148-date-of-birth-field-enhancement': string;
  'feat-000153-display-multiple-flights-on-meta-search': string;
  'feat-000162-uplift-on-payment': string;
  'feat-000173-redesigned-bags-ancillary-page': string;
  'feat-000174-redesigned-meals-ancillary-page': string;
  'feat-000176-link-to-dohop-from-od-picker': string;
  'feat-000178-upsell-to-economy-classic-modal': string;
  'feat-000179-no-bags-selected-upsell-modal': string;
  'feat-000180-tolstoy-video-cabin-promo-flights': string;
  'feat-000183-hotjar-feedback-bookingflow': string;
  'feat-000190-insurance-product-in-UK': string;
  'feat-000192-add-breadcrumb-header-desktop': string;
  'feat-000197-positive-reinforcement-messaging-payment': string;
  'feat-000200-flag-for-locale-frontpage': string;
  'feat-000266-15kg-carryon-for-premium': string;
  'feat-000267-add-countdown-timer-paymentpage': string;
  'feat-000272-highlight-10percentile-lowfare-calendar': string;
  'feat-000273-previous-searches-available-on-frontpage': string;
  'feat-000281-shortcut-oneway-calendar': string;
  'feat-000289-redesigned-extras-ancillary-page': string;
  'feat-000344-verified-by-norse': string;
  'feat-000351-urgency-messaging-on-flights-weekview': string;
  'feat-000352-shortcut-month-picker-calendar': string;
  'feat-000354-redesigned-destinations-page': string;
  'feat-000355-as-featured-in-news-banner': string;
  'feat-000356-testimonials-on-front-page': string;
  'feat-000366-dohop-v2-top-connections': string;
  'feat-000369-promocode-landingpage': string;
  'feat-000381-hide-optionalinfo-travelers': string;
  'feat-000383-urgency-inside-confirmpay': string;
  'feat-000384-split-inputfield-passport-dates': string;
  'feat-000385-redesign-input-countrycode-residency': string;
  'feat-000387-remove-previous-flight-cta': string;
  'feat-000397-money-back-guarantee-on-payment': string;
  'feat-000412-fare-brand-pricing-in-cta': string;
  'feat-000413-money-back-guarantee-on-front-page': string;
  'feat-000414-select-dates-before-fare-brands': string;
  'feat-000437-fast-track-strikethrough-pricing': string;
  'feat-000449-replace-stickyfooter-booking-desktop': string;
  'feat-000455-hotel-car-extras-frontpage': string;
  'feat-000458-travelers-first-in-flow': string;
  'feat-000469-seat-selection-with-one-click': string;
  'feat-000473-select-your-cabin-text-on-flights': string;
  'feat-000481-add-spanish-esUS-language': string;
  'feat-000485-suggested-email-domains-travelers': string;
  'feat-000493-reduce-available-seats': string;
  'feat-000498-remove-cta-search-frontpage': string;
  'feat-000505-bgcolor-cta-frontpage-search': string;
  'feat-000515-datepicker-search-widget-frontpage': string;
  'feat-000530-attribute-change-continue-button': string;
  'feat-000531-aatest': string;
  'feat-000558-session-timeout-autoextend': string;
  'feat-000559-session-timeout-relabeling': string;
  'feat-000560-fully-clickable-fare-brand-card': string;
  'feat-000561-sticky-flight-search-on-front-page': string;
  'feat-000562-destinations-promotion-on-front-page': string;
  'feat-000563-promote-norse-usps-on-front-page': string;
  'feat-000566-social-media-links-on-front-page': string;
  'feat-000572-promocode-front-campaigns': string;
  'feat-000581-show-premium-when-sold-out': string;
  'feat-000584-move-cta-placement-in-booking-flow': string;
  'feat-000595-frontpage-components-ordering': string;
  'feat-000606-main-text-frontpage-search': string;
  'feat-000619-multiple-sessions-notification': string;
  'feat-000633-improved-language-currency-picker': string;
  'feat-000634-main-CTA-text-bookingflow': string;
  'feat-000638-bgcolor-mainCTA-bookingflow': string;
  'feat-000643-odins-wingman-lowfare-calendar': string;
  'feat-000653-new-fare-brand-cards-desktop': string;
  'feat-000654-new-fare-brand-cards-mobile': string;
  'feat-000676-EL-XBAG-to-EC-upgrade': string;
  'feat-000678-combine-winners': boolean;
  'feat-000735-interstitial-loading-screen': string;
  'feat-000815-autoscroll-to-fare-brand-selection-v2': string;
  'feat-000837-add-trip-details-paymentpage': string;
  'feat-000853-extras-SSRs-strikethrough-pricing': string;
  'feat-000882-fare-information-disclaimer-flights': string;
  'feat-000884-phone-email-required-on-payment': string;
  'feat-000902-promo-code-on-round-trip': string;
  'feat-000913-reorder-fare-brands': string;
  'feat-000952-click-to-add-seat-without-select-button': string;
  'feat-000993-different-info-on-seats': string;
  'feat-1022-frontpage-banner-on-off': string;
  'feat-001024-time-saver-bundle': string;
  'feat-001052-pdf-invoice': boolean;
  'feat-001077-multicity': string;
  'feat-001088-new-legend-and-details-seats-map': string;
  'feat-001095-multiapp': boolean;
  'feat-001103-Change-20XX-in-payment-details-page_1': string;
  'feat-001105-multiapp-notification-text': string;
  'feat-001113-sold-out-lowfare-calendar': string;
  'feat-001116-dohop-fully-integrated': string;
  'feat-001117-dohop-as-alternative-to-direct': string;
  'feat-001128-read-more-destination-pages': string;
  'feat-0001132-store-traveler-information-v1': string;
  'feat-001178-modify-ticket-type-show-all-flights': string;
  'feat-001203-seat-map-page-with-3d-panorama': string;
  'feat-001212-mmb-front-page-redesign': string;
  'feat-001220-abandoned-cart': string;
  'feat-001236-sentry-enabled': boolean;
  'feat-001236-sentry-replay-on-error-sample-rate': number;
  'feat-001236-sentry-session-replay-sample-rate': number;
  'feat-001236-sentry-trace-sample-rate': number;
  'feat-001288-seat-initials-in-seat-map': string;
  'feat-001308-change-background-color-lightblue': string;
  'feat-001326-24h-cancellation-label-flight-card': boolean;
  'feat-001354-improved-travelers-page-highlighted-fields': string;
  'feat-001364-pending-payment-notification': string;
  'feat-001368-CB10-now-included-promotion': string;
  'feat-001404-seats-not-on-hold-payment-page': string;
  'feat-001405-cover-genius-US-layout': string;
  'feat-001411-add-access-token-in-auth-header': boolean;
  'feat-001416-change-search-area-to-media-content-ROW': string;
  'feat-001416-change-search-area-to-media-content-US': string;
  'feat-001425-hold-my-fare': string;
  'feat-001433-top-menu-reordering': string;
  'feat-001439-notification-banner-payment-page': string;
  'feat-001449-design-alignments-frontpage': string;
  'feat-001458-animated-skeleton-loader-weekview': string;
  'feat-001471-OW-RTD-MC-visible-over-search-widget': string;
  'feat-001472-round-trip-discount-alerts': string;
  'feat-001521-treat24-icon-lowfare': string;
  'feat-001522-disable-google-geolocation': string;
  'feat-001543-promo-code-label-payment-page': string;
  'feat-001545-new-simplified-bundle-structure': string;
  'feat-001557-humanized-ancillaries-hotel-car-parkin': string;
  'feat-001562-concise-pop-ups-seats-meals-bags-connections-etc': string;
  'feat-001600-compress-design-mobile': string;
  'feat-001611-commercial-bubble-frontpage': string;
  'feat-001650-eco-friendly-page': string;
  'feat-001666-your-trip-card-improvement': string;
  'feat-001692-flexpay-earlier-in-booking-flow': string;
  'feat-001705-MMB-change-flow-popup': string;
  'feat-001728-skytrax-badge': string;
  'feat-001732-input-field-cleanup': string;
  'feat-001737-new-newsletter-pop-up-frontpage': string;
  'feat-001761-limited-availability-notification-on-payment-page': string;
  'feat-001847-MMB-flights-not-including-low-fare-prices': string;
  'feat-001849-redesign-more-info-popup': string;
  'feat-001855-redesign-navigation': string;
  'feat-001893-car-rental-header-popup-deeplink': string;
  'feat-001899-eligible-for-upgrade': string;
  'feat-001900-Change-logic-cabin-promo': string;
  'feat-001901-fast-track-passport-control-Gatwick': string;
  'feat-001902-go-anywhere': string;
  'feat-001906-sitting-together-option-in-seat-map': string;
  'feat-001934-mmb-confirmation-redesign': string;
  'feat-001974-block-apg-mmb': string;
  'feat-001984-New-payment-module-at-payment-page': string;
  'feat-001985-New-payment-module-with-hosted-payment-page': string;
  'feat-001996-destinations-map-redesign': string;
  'feat-002042-cover-genius': boolean;
  'feat-002052-new-legend-details-seat-map-v2': string;
  'feat-002118-free-flight-change': string;
  'feat-002180-sentry-feedback-form': boolean;
  'feat-002191-skip-to-payment-button': string;
  'feat-002223-remove-promo-label-on-tactical-fares': boolean;
  'feat-002239-skip-seat-selection-education': string;
  'feat-002261-price-delta-sensitivity': string;
  'feat-002262-price-delta-sensitivity': string;
  'feat-002280-home-page-background-image-size': string;
  'feat-002313-new-loading-screens': string;
  'feat-002315-destination-selection-before-origin': string;
  'feat-002324-show-flight-number-on-card': string;
  'feat-002341-cloudflare-geolocation': string;
  'feat-002379-seatmap-PremiumUpgrade': string;
  'feat-002389-turning-off-cultures': string;
  'feat-2405-where-we-fly-redesign': string;
  'feat-002420-blank-page-on-flight-impact': boolean;
  'feat-002430-corporate-credit-card-fee': string;
  'feat-002474-Partner-message-when-deeplinking': string;
  'feat-002524-travelers-page-disabled-cta-before-done-is-possible': string;
  'feat-002622-skybid-mmb-flights-page-revamp': string;
  'feat-002688-online-check-in': boolean;
  'feat-002730-round-trip-discount': string;
  'feat-002747-checkin-guardrails-passengers': string;
  'feat-002753-skybid-mmb-simplified-payment-page': string;
  'feat-002760-new-airport-lounge-ARL': string;
  'feat-002785-booking-confirmation-via-brevo': string;
  'feat-002801-skybid-mmb-home-page-revamp-v1': string;
  'feat-002814-doccheck-popup-booking-flow': string;
  'feat-002815-doccheck-popup-MMB': string;
  'feat-002818-skybid-mmb-home-page-revamp-v2': string;
  'feat-002959-posthog-enabled': boolean;
  'feat-002986-skybid-mmb-home-page-revamp-v3': string;
  'feat-002989-skybid-mmb-upgrade-flow-compressed': string;
  'feat-003006-view-boarding-pass-button': string;
  'feat-003014-sitting-together-option-in-modal': string;
  'feat-003026-standardize-all-flynorse-icons': string;
  'feat-003125-updated-ancillary-pop-up-logic': string;
  'feat-003126-skybid-mmb-home-page-revamp-v4': string;
  'feat-003127-skybid-mmb-home-page-revamp-v5': string;
  'feat-003128-skybid-mmb-home-page-revamp-v6': string;
  'feat-003129-confirmation-page-app-download-banner': string;
  'feat-003130-mmb-page-app-download-banner': string;
  'feat-003240-your-trips-page-improvement': string;
  'feat-003241-price-display-on-payment-pages': string;
  'feat-003277-updated-cta-in-change-flight-flow': string;
  'feat-003322-your-trip-navigation-bar-placement': string;
  'feat-003323-clarify-journey-selection-before-flight-change-flow': string;
  'feat-003358-add-change-fee-to-upgrade-path': boolean;
  'feat-003366-no-middle-seat-ssr': string;
  'feat-003367-book-tab-underlined': string;
  'feat-003369-upgrade-path-flights-page-revamp-v2': string;
  'feat-003387-aa-test': string;
  'feat-003399-Clarifying-final-step-OCI': string;
  'feat-003405-bags-price-99': string;
  'feat-003406-meals-price-99': string;
  'feat-003407-extras-price-99': string;
  'feat-003419-upgrade-flow-exit-intent-popup': string;
  'feat-003448-market-beverages-premium': string;
  'feat-003449-ability-select-destination-determine-departure-airport': string;
  'feat-003477-skip-seat-selection-v2': string;
  'feat-003478-increse-session-timeout-v2': string;
  'feat-003483-new-mobile-number-validation': string;
  'feat-003486-updated-ancillary-pop-up-logic-v2': string;
  'feat-003487-sticky-bottom-bar-booking-flow': string;
  'feat-eco334-money-back-guarantee': string;
  'feat-ndp-2797-premium-diff-to-economy-lf-balancing': string;
  'gbdemo-checkout-layout': string;
  'test_feature_apo': string;
  'test_ndp_bjorneirik': string;
  'test-000123-02-human-friendly-short-name': string;
  'test-feature-02-boolean': boolean;
  'test-feature-04-number': number;
  'test-feature-05-json': Record<string, unknown>;
  'test-feature-06-ab': Record<string, unknown>;
  'test-feature-07-mvt': Record<string, unknown>;
  'test-feature-08-evo': Record<string, unknown>;
  'test-feature-09-from-exp': string;
  'test-feature-11-forced-var': string;
  'test-feature-customparameter': string;
  'test-features-enabled': boolean;
}


/**
  * @deprecated This enum should not be used. Use the inferred keys from AppFeatures instead.
  * Example: growthBook.isOn('feat-00001-some-random-feature')
*/
export enum GrowthBookFeatureKeys {
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_US929_CB10_INCLUDED_WITH_ECONOMY_LIGHT = 'feat_000929_ndp_cb10_included_economy_light',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_US930_FREE_SEAT_PREMIUM_CLASSIC = 'feat_000930_ndp_seat_included_premium_classic',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_000127_CABIN_PROMO_MODULE_DESKTOP = 'feat-000127-cabin-promo-module-desktop',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_000129_CABIN_PROMO_MODULE_MOBILE = 'feat-000129-cabin-promo-module-mobile',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_US130_CARD_NUMBER_MASK = 'feat-000130-credit-card-number-spacing-enhancement',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_US131_DISABLE_CONTINUE_BUTTON_UNDER_MODIFY_TICKET_ACTION = 'feat-000131-disable-continue-button-under-modify-ticket-action',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_US132_MESSAGING = 'feat-000132-urgency-and-positive-reinforcement-messaging-flights',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_US162_UPLIFT_ON_PAYMENT = 'feat-000162-uplift-on-payment',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_US173_REDESIGNED_BAGS_PAGE = 'feat-000173-redesigned-bags-ancillary-page',
  /** @member {string} */
  /** Owner: Peer */
  FEAT_US174_NEW_MEALS = 'feat-000174-redesigned-meals-ancillary-page',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_US176_DOHOP_LINK = 'feat-000176-link-to-dohop-from-od-picker',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_US178_UPSELL_TO_ECONOMY = 'feat-000178-upsell-to-economy-classic-modal',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_US179_NO_BAGS_ARE_SELECTED = 'feat-000179-no-bags-selected-upsell-modal',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_US180_TOLSTOY_VIDEO_CABIN_PROMO_FLIGHTS = 'feat-000180-tolstoy-video-cabin-promo-flights',
  /** @member {string} */
  /** Owner: Peer */
  FEAT_US183_HOTJAR_FEEDBACK_BOOKINGFLOW = 'feat-000183-hotjar-feedback-bookingflow',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_US197_PAYMENT_POSITIVE_MESSAGE = 'feat-000197-positive-reinforcement-messaging-payment',
  /** @member {string} */
  /** Owner: Peer */
  FEAT_US266_15KG_CARRYON_FOR_PREMIUM = 'feat-000266-15kg-carryon-for-premium',
  /** @member {string} */
  /** Owner: Peer */
  FEAT_US267_COUNTDOWN_TIMER_PAYMENTPAGE = 'feat-000267-add-countdown-timer-paymentpage',
  /** @member {string} */
  /** Owner: Peer */
  FEAT_US272_10PERCENT_CHEAPEST_FLIGHTS = 'feat-000272-highlight-10percentile-lowfare-calendar',
  /** @member {string} */
  /** Owner: Peer */
  FEAT_US273_PREVIOUS_SEARCHES_AVAILABLE_ON_FRONTPAGE = 'feat-000273-previous-searches-available-on-frontpage',
  /** @member {string} */
  /** Owner: Peer */
  FEAT_US281_SHORTCUT_ONEWAY_CALENDAR = 'feat-000281-shortcut-oneway-calendar',
  /** @member {string} */
  /** Owner: Peer */
  FEAT_US289_REDESIGNED_EXTRAS_ANCILLARY = 'feat-000289-redesigned-extras-ancillary-page',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_US344_VERIFIED_BY_NORSE = 'feat-000344-verified-by-norse',
  /** @member {string} */
  /** Owner: Peer */
  FEAT_US351_URGENCY_MESSAGING_ON_WEEK_VIEW = 'feat-000351-urgency-messaging-on-flights-weekview',
  /** @member {string} */
  /** Owner: Peer */
  FEAT_US352_SHORTCUT_MONTH_PICKER_CALENDAR = 'feat-000352-shortcut-month-picker-calendar',
  /** @member {string} */
  /** Owner: Peer */
  FEAT_US354_REDESIGNED_DESTINATIONS_PAGE = 'feat-000354-redesigned-destinations-page',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_US355_AS_FATURED_IN_NEWS_BANNER = 'feat-000355-as-featured-in-news-banner',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_US356_TESTIMONIALS_ON_FRONT_PAGE = 'feat-000356-testimonials-on-front-page',
  /** @member {string} */
  /** Owner: Peer */
  FEAT_US366_DOHOP_V2_TOP_CONNECTIONS = 'feat-000366-dohop-v2-top-connections',
  /** @member {string} */
  /** Owner: Peer */
  FEAT_US369_PROMOCODE_LANDINGPAGE = 'feat-000369-promocode-landingpage',
  /** @member {string} */
  /** Owner: Peer */
  FEAT_US381_HIDE_OPTIONALINFO_TRAVELERS = 'feat-000381-hide-optionalinfo-travelers',
  /** @member {string} */
  /** Owner: Peer */
  FEAT_US383_URGENCY_INSIDE_CONFIRMPAY = 'feat-000383-urgency-inside-confirmpay',
  /** @member {string} */
  /** Owner: Peer */
  FEAT_US384_SPLIT_INPUT_FIELD_PASSPORT_DATES = 'feat-000384-split-inputfield-passport-dates',
  /** @member {string} */
  /** Owner: Peer */
  FEAT_US385_REDESIGN_INPUT_COUNTRYCODE_RESIDENCY = 'feat-000385-redesign-input-countrycode-residency',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_US397_MONEY_BACK_GUARANTEE_ON_PAYMENT = 'feat-000397-money-back-guarantee-on-payment',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_US412_FARE_BRAND_PRICING_CTA = 'feat-000412-fare-brand-pricing-in-cta',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_US413_MONEY_BACK_GUARANTEE_ON_FRONT_PAGE = 'feat-000413-money-back-guarantee-on-front-page',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_US414_SELECT_DATES_BEFORE_FARE_BRANDS = 'feat-000414-select-dates-before-fare-brands',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_US437_FAST_TRACK_STRIKE_THROUGH_PRICING = 'feat-000437-fast-track-strikethrough-pricing',
  /** @member {string} */
  /** Owner: Peer */
  FEAT_US449_REPLACE_STICKYFOOTER_BOOKING_DESKTOP = 'feat-000449-replace-stickyfooter-booking-desktop',
  /** @member {string} */
  /** Owner: Peer */
  FEAT_US445_HOTEL_CAR_EXTRAS_FRONTPAGE = 'feat-000455-hotel-car-extras-frontpage',
  /** @member {string} */
  /** Owner: Peer */
  FEAT_US458_TRAVELERS_FIRST_IN_FLOW = 'feat-000458-travelers-first-in-flow',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_US69_NO_SEAT_TOOLTIP = 'feat-000469-seat-selection-with-one-click',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_US447_SELECT_YOUR_CABIN_TEXT_ON_FLIGHTS = 'feat-000473-select-your-cabin-text-on-flights',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_US481_ADD_ES_US = 'feat-000481-add-spanish-esUS-language',
  /** @member {string} */
  /** Owner: Peer */
  FEAT_US485_SUGGESTED_EMAIL_DOMAINS_TRAVELERS = 'feat-000485-suggested-email-domains-travelers',
  /** @member {string} */
  /** Owner: Peer */
  FEAT_US493_REDUCE_AVAILABLE_SEATS = 'feat-000493-reduce-available-seats',
  /** @member {string} */
  /** Owner: Peer */
  FEAT_498_REMOVE_CTA_SEARCH_FRONTPAGE = 'feat-000498-remove-cta-search-frontpage',
  /** @member {string} */
  /** Owner: Peer */
  FEAT_US505_BGCOLOR_CTA_FRONTPAGE_SEARCH = 'feat-000505-bgcolor-cta-frontpage-search',
  /** @member {string} */
  /** Owner: Peer */
  FEAT_US515_DATEPICKER_SEARCH_WIDGET_FRONTPAGE = 'feat-000515-datepicker-search-widget-frontpage',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_US530_ATTRIBUTE_CHANGE_CONTINUE_BUTTON = 'feat-000530-attribute-change-continue-button',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_US531_VALIDATE_GROWTHBOOK_IMPLEMENTATION = 'feat-000531-aatest',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_US558_SESSION_AUTOEXTEND = 'feat-000558-session-timeout-autoextend',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_US559_SESSION_RELABELING = 'feat-000559-session-timeout-relabeling',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_US560_CLICKABLE_FARE_BRAND_CARD = 'feat-000560-fully-clickable-fare-brand-card',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_US561_STICKY_FLIGHT_SEARCH_ON_FRONT_PAGE = 'feat-000561-sticky-flight-search-on-front-page',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_US562_DESTINATIONS_PROMOTIONS_ON_FRONT_PAGE = 'feat-000562-destinations-promotion-on-front-page',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_US563_PROMOTE_NORSE_USPS_ON_FRONT_PAGE = 'feat-000563-promote-norse-usps-on-front-page',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_US566_SOCIAL_MEDIA_LINKS_ON_FRONT_PAGE = 'feat-000566-social-media-links-on-front-page',
  /** @member {string} */
  /** Owner: Peer */
  FEAT_US572_PROMOCODE_FRONT_CAMPAIGNS = 'feat-000572-promocode-front-campaigns',
  /** @member {string} */
  /** Owner: Peer */
  FEAT_US581_SHOW_PREMIUM_WHEN_SOLD_OUT = 'feat-000581-show-premium-when-sold-out',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_US584_MOVE_CTA_PLACEMENT_IN_BOOKING_FLOW = 'feat-000584-move-cta-placement-in-booking-flow',
  /** @member {string} */
  /** Owner: Peer */
  FEAT_US595_FRONT_PAGE_COMPONENTS_ORDERING = 'feat-000595-frontpage-components-ordering',
  /** @member {string} */
  /** Owner: Peer */
  FEAT_US606_MAIN_TEXT_FRONTPAGE_SEARCH = 'feat-000606-main-text-frontpage-search',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_US633_IMPROVED_LANG_CURRENCY_PICKER = 'feat-000633-improved-language-currency-picker',
  /** @member {string} */
  /** Owner: Peer */
  FEAT_US634_MAIN_CTA_TEXT_BOOKINGFLOW = 'feat-000634-main-CTA-text-bookingflow',
  /** @member {string} */
  /** Owner: Peer */
  FEAT_US638_BG_CTA_BOOKING = 'feat-000638-bgcolor-mainCTA-bookingflow',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_US643_ODINS_WINGMAN_LOWFARE_CALENDAR = 'feat-000643-odins-wingman-lowfare-calendar',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_US653_NEW_FARE_BRAND_CARDS_DESKTOP = 'feat-000653-new-fare-brand-cards-desktop',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_US654_NEW_FARE_BRAND_CARDS_MOBILE = 'feat-000654-new-fare-brand-cards-mobile',
  /** @member {string} */
  /** Owner: Peer */
  FEAT_US676_EL_XBAG_TO_EC_UPGRADE = 'feat-000676-EL-XBAG-to-EC-upgrade',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_US735_INTERSTITIAL_LOADING_SCREEN = 'feat-000735-interstitial-loading-screen',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_US815_AUTO_SCROLL_TO_FARE_BRAND_SELECTION_V2 = 'feat-000815-autoscroll-to-fare-brand-selection-v2',
  /** @member {string} */
  /** Owner: Peer */
  FEAT_US837_ADD_TRIP_SUMMARY_ON_PAYMENT_PAGE = 'feat-000837-add-trip-details-paymentpage',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_US853_EXTRAS_SSRS_STRIKETHROUGH_PRICING = 'feat-000853-extras-SSRs-strikethrough-pricing',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_US882_FARE_INFORMATION_DISCLAIMER_FLIGHTS = 'feat-000882-fare-information-disclaimer-flights',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_US884_EXTRA_3DS_PAYMENT_FIELDS = 'feat-000884-phone-email-required-on-payment',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_US902_PROMO_CODE_ON_ROUND_TRIP = 'feat-000902-promo-code-on-round-trip',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_US913_REORDER_FARE_BRANDS = 'feat-000913-reorder-fare-brands',
  /** @member {string} */
  /** Owner: Patrick */
  FEAT_US952_CLICK_TO_ADD_SEAT_WITHOUT_SELECT_BUTTON = 'feat-000952-click-to-add-seat-without-select-button',
  /** @member {string} */
  /** Owner: Patrick */
  FEAT_US993_DIFFERENT_INFO_ON_SEATS = 'feat-000993-different-info-on-seats',
  /** @member {string} */
  /** Owner: Peer */
  FEAT_US1022_FRONT_PAGE_BANNER_ON_OFF = 'feat-1022-frontpage-banner-on-off',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_1052_PDF_INVOICE = 'feat-001052-pdf-invoice',
  /** @member {string} */
  /** Owner: Peer */
  FEAT_US1077_MULTICITY = 'feat-001077-multicity',
  /** @member {string} */
  /** Owner: Patrick */
  FEAT_US1088_NEW_LEGEND_AND_DETAILS_SEATS_MAP = 'feat-001088-new-legend-and-details-seats-map',
  /** @member {string} */
  /** Owner: Patrick */
  FEAT_001103_CHANGE_20XX_IN_PAYMENT_DETAILS_PAGE_1 = 'feat-001103-Change-20XX-in-payment-details-page_1',
  /** @member {string} */
  /** Owner: Peer */
  FEAT_US1113_SOLD_OUT_LOW_FARE_CALENDAR = 'feat-001113-sold-out-lowfare-calendar',
  /** @member {string} */
  /** Owner: Patrick */
  FEAT_US1132_STORE_TRAVELER_INFORMATION_V1 = 'feat-0001132-store-traveler-information-v1',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_US001178_MODIFY_TICKET_TYPE_SHOW_ALL_FLIGHTS = 'feat-001178-modify-ticket-type-show-all-flights',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_1236_SENTRY_ENABLED = 'feat-001236-sentry-enabled',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_1236_SENTRY_REPLAY_ON_ERROR_SAMPLE_RATE = 'feat-001236-sentry-replay-on-error-sample-rate',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_1236_SENTRY_SESSION_REPLAY_SAMPLE_RATE = 'feat-001236-sentry-session-replay-sample-rate',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_1236_SENTRY_TRACE_SAMPLE_RATE = 'feat-001236-sentry-trace-sample-rate',
  /** @member {string} */
  /** Owner: Patrick */
  FEAT_1288_SEAT_INITIALS_IN_SEAT_MAP = 'feat-001288-seat-initials-in-seat-map',
  /** @member {string} */
  /** Owner: Hilina */
  FEAT_1354_IMPROVED_TRAVELERS_PAGE_HIGHLIGHTED_FIELDS = 'feat-001354-improved-travelers-page-highlighted-fields',
  /** @member {string} */
  /** Owner: Patrick */
  FEAT_US1368_CB10_NOW_INCLUDED_PROMOTION = 'feat-001368-CB10-now-included-promotion',
  /** @member {string} */
  /** Owner: Thomas */
  FEAT_ECO334_MONEY_BACK_GUARANTEE = 'feat-eco334-money-back-guarantee',
}
